import React from 'react';
import { UiIcon } from 'ui-components';
import { useTranslation } from 'react-i18next';
import { StyledNetworkStatusError } from './NetworkStatusError.styles';

function NetworkStatusError() {
  const { t } = useTranslation();
  return (
    <StyledNetworkStatusError>
      <UiIcon className='alert-icon' icon='ri-wifi-off-line' size={40} />
      <div className='alert-container'>
        <span className='alert-title'>{t('error:noNetwork')}</span>
        <span className='alert-description'>{t('error:refreshPage')}</span>
      </div>
    </StyledNetworkStatusError>
  );
}

export default NetworkStatusError;
